import { render, staticRenderFns } from "./channelConsume.vue?vue&type=template&id=ae6cd646&scoped=true"
import script from "./channelConsume.vue?vue&type=script&lang=js"
export * from "./channelConsume.vue?vue&type=script&lang=js"
import style0 from "./channelConsume.vue?vue&type=style&index=0&id=ae6cd646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6cd646",
  null
  
)

export default component.exports